import React, { useEffect, useState } from "react";
import { Card as AntCard, Avatar, Checkbox } from "antd";
const { Meta } = AntCard;

import SqftIcon from "@/assets/svg/SqftIcon";
import BedIcon from "@/assets/svg/BedIcon";
import { Link } from "react-router-dom";
import { imgPath } from "@/constants/miscConstants";
import { MarkPropertyFavorites } from "../Favorite";
import FeaturedRibbon from "../FeaturedRibbon";
import CurrencyExchange from "@/common/atoms/lable/CurrencyExchange";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/hook/useLanguage";
import BathIcon from "@/assets/svg/BathroomIcon";
import Button from "@/common/atoms/Button";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import LocationLabel from "@/common/atoms/lable/Location";
import AppBadge from "@/common/atoms/Badge";
import { getTranslatedAreaUnit } from "@/utils";

const PropertyCardListing = ({
  propertyItems,
  isCompare,
  handleCompareSelection,
  isChecked,
  isDisabled
}) => {
  const [checked, setChecked] = useState(isChecked);
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleCheckboxChange = (e) => {
    if (!isDisabled || checked) {
      setChecked(e.target.checked);
      handleCompareSelection(propertyItems);
    }
  };

  const translatedUnit = getTranslatedAreaUnit(
    propertyItems?.propertySizePostfix,
    t
  );

  const Amenity = ({ icon, title }) => (
    <div className="flex items-center gap-2">
      {icon}
      <p className="truncate font-sans font-normal mx-1 text-[#010F0A]">
        {title}
      </p>
    </div>
  );

  const cardDescription = () => (
    <div className="mb-2">
      <div className="flex items-center justify-between flex-wrap">
        <Amenity
          title={`${propertyItems?.noBedroom || 0} ${t("card.bed")}`}
          icon={<BedIcon color={"#000000"} />}
        />
        <Amenity
          title={`${propertyItems?.noBathroom || 0} ${t("card.bath")}`}
          icon={<BathIcon color={"#000000"} />}
        />
        <Amenity
          title={`${propertyItems.propertySize} ${translatedUnit}`}
          icon={<SqftIcon color={"#000000"} />}
        />
      </div>
      <div className="my-2 flex items-center justify-between mt-4">
        <CurrencyExchange propertyPrice={propertyItems?.propertyPrice} />
        <Link to={`/property-detail/${propertyItems?.uuid}`}>
          <Button
            className="!rounded-lg !py-[18px] !px-4"
            type="link"
            icon={isRTL ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}
            iconPosition="end">
            {t("card.view")}
          </Button>
        </Link>
      </div>
    </div>
  );
  const imgUrl = propertyItems?.propertyThumbnailUrl || imgPath;
  return (
    <Link to={`/property-detail/${propertyItems?.uuid}`}>
      <div className="relative mx-2">
        <AntCard
          className="my-2 rounded-2xl border-transparent shadow-[0px_0px_20px_0px_#0000001A] [&_.ant-card-body]:!p-3 [&_.ant-card-cover]:!p-[6px]"
          styles={{
            body: {
              padding: "0px"
            }
          }}
          cover={
            <div className="relative flex">
              <Avatar
                shape="square"
                src={imgUrl}
                alt={propertyItems.name}
                style={{
                  width: "100%",
                  height: 230,
                  borderRadius: "12px",
                  objectFit: "cover"
                }}
              />

              {propertyItems?.isFeatured && (
                <FeaturedRibbon text={t("propertyDetails.featured")} />
              )}
              <MarkPropertyFavorites
                isFavourite={propertyItems?.isFavourite}
                propertyId={propertyItems?.uuid}
                userId={propertyItems?.userId}
                fillColor="#7B9E7E"
              />
              <AppBadge
                propertyListingType={propertyItems?.propertyListingType}
                classes={`mx-2 absolute left-2 rtl:bottom-4 ltr:bottom-2`}
              />
            </div>
          }>
          <Meta
            title={
              <div className="flex flex-col gap-1">
                <LocationLabel location={propertyItems} />
                <p className="text-lg md:text-xl mb-1 font-manropeMedium  text-secondary truncate capitalize">
                  {propertyItems.name}
                </p>
              </div>
            }
            description={cardDescription()}
          />
        </AntCard>
        {isCompare && (
          <div
            className="-mt-5 mb-2"
            onClick={(e) => {
              e.stopPropagation();
            }}>
            <Checkbox
              className={`compare-checkbox w-full flex justify-around font-sans items-center px-4 pt-5 pb-3 
              rounded-br-2xl rounded-bl-2xl transition-colors duration-300 [&.ant-checkbox-wrapper>.ant-checkbox]:mt-0.5
              ${
                checked
                  ? "bg-gradient-to-r from-[#7B9E7E] to-[#31493C] text-white"
                  : "bg-[#D9D9D9] text-[#6C7072]"
              }
              ${
                isDisabled && !checked ? "cursor-not-allowed" : "cursor-pointer"
              }`}
              checked={checked}
              disabled={isDisabled && !checked}
              onChange={handleCheckboxChange}>
              {t("common.compare")}
            </Checkbox>
          </div>
        )}
      </div>
    </Link>
  );
};
export default React.memo(PropertyCardListing);
